export default "__VITE_ASSET__DrxTK8li__"